import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
		<path d="M7.29167 9.95833V7.29167M7.29167 4.625H7.29833M13.9583 7.29167C13.9583 10.9736 10.9736 13.9583 7.29167 13.9583C3.60977 13.9583 0.625 10.9736 0.625 7.29167C0.625 3.60977 3.60977 0.625 7.29167 0.625C10.9736 0.625 13.9583 3.60977 13.9583 7.29167Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);